import { render, staticRenderFns } from "./Quote-PSA_PCP_ONLY.vue?vue&type=template&id=117458c7&scoped=true"
import script from "./Quote-PSA_PCP_ONLY.vue?vue&type=script&lang=js"
export * from "./Quote-PSA_PCP_ONLY.vue?vue&type=script&lang=js"
import style0 from "./Quote-PSA_PCP_ONLY.vue?vue&type=style&index=0&id=117458c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117458c7",
  null
  
)

export default component.exports